"use client";

import type { FormEvent } from "react";

type LobbyProps = {
  busy: boolean;
  connected?: boolean;
  error?: boolean;
  inviteUrl?: string;
  onCopyInvite?: () => void;
  onJoin: () => void;
  onRoomChange: (room: string) => void;
  room: string;
  status: string;
};

export function Lobby({
  busy,
  connected = false,
  error = false,
  inviteUrl,
  onCopyInvite,
  onJoin,
  onRoomChange,
  room,
  status,
}: LobbyProps) {
  const submit = (event: FormEvent) => {
    event.preventDefault();
    if (!busy && room.length >= 6) onJoin();
  };

  return (
    <main className="lobby-shell">
      <span className="version">BWWK P2P / Version 1.0</span>
      <section aria-labelledby="game-title" className="lobby-panel">
        <p className="brand-kicker">FORENSIC WEB RECREATION / 2011 RULES</p>
        <h1 className="brand-title" id="game-title">
          BLOCK WAKUWAKU
          <br />
          KINGDOM
        </h1>
        <p className="brand-subtitle">P2P BATTLE</p>

        <form className="room-form" onSubmit={submit}>
          <label htmlFor="room-code">ROOM</label>
          <input
            autoComplete="off"
            className="room-code"
            disabled={busy}
            id="room-code"
            inputMode="text"
            maxLength={12}
            minLength={6}
            onChange={(event) =>
              onRoomChange(
                event.target.value
                  .toUpperCase()
                  .replace(/[^ABCDEFGHJKLMNPQRSTUVWXYZ23456789]/gu, ""),
              )
            }
            pattern="[ABCDEFGHJKLMNPQRSTUVWXYZ23456789]{6,12}"
            placeholder="7KR4Q2MN"
            spellCheck={false}
            value={room}
          />
          <button className="chrome-button" disabled={busy || room.length < 6} type="submit">
            {connected ? "接続完了" : busy ? "接続中…" : "部屋に入る"}
          </button>
        </form>

        <p aria-live="polite" className={`lobby-status${error ? " error" : ""}`} role="status">
          {status}
        </p>
        {connected && inviteUrl ? (
          <button className="invite-link" onClick={onCopyInvite} type="button">
            招待URLをコピー
          </button>
        ) : null}
      </section>
    </main>
  );
}
